import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  Optional,
  Self,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import {AutonumericDirective} from '../../directives/autonumeric.directive';
import {MessageService} from '../../services/message-service.service';
import {ControlValueAccessor, FormControl, NgControl} from '@angular/forms';
import {ErrorStateMatcher} from '@angular/material/core';

class CustomFieldErrorMatcher implements ErrorStateMatcher {
  constructor(private customControl: FormControl) { }
  isErrorState(): boolean {
    return this.customControl && this.customControl.touched && (this.customControl.invalid);
  }
}

@Component({
  selector: 'app-percent-input',
  templateUrl: './app-percent-input.component.html',
  styleUrls: [],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppPercentInputComponent implements ControlValueAccessor, OnChanges {

  readonly defaultOptions = {
    digitGroupSeparator: ',',
    decimalCharacter: '.',
    decimalCharacterAlternative: '.',
    minimumValue: '0',
    maximumValue: 100.00,
    decimalPlaces: 2,
    decimalPlacesShownOnBlur: 2,
    watchExternalChanges: true
  };

  @ViewChild(AutonumericDirective) input: AutonumericDirective;
  @Input()
  get isRequired(): boolean { return this._required; }
  set isRequired(value: boolean) { this._required = value; }
  @Input()
  get readonly(): boolean { return this._readonly; }
  set readonly(value: boolean) { this._readonly = value; }

  constructor(private messageService: MessageService,
              @Self() @Optional() public ctrl: NgControl) {
    if (this.ctrl) {
      this.ctrl.valueAccessor = this;
    }
  }
  @Input() public placeholder: string;
  @Input() public testId: string;
  @Input() public hideLabel?: boolean;
  @Input() public inputLabel?: string;
  @Input() public inputHint?: string;
  @Input() public warningMessage?: string;
  @Input() public isWarningVisible?: boolean;
  @Input() public inputClass?: string;
  @Input() public isTouched: string;

  // tslint:disable-next-line:variable-name
  private _required: boolean; private _readonly: boolean;

  currencyControlOptions = Object.assign(this.defaultOptions);

  onChange: any = () => { };
  onTouched: any = () => { };

  public errorMatcher() {
    return new CustomFieldErrorMatcher(this.ctrl.control as FormControl);
  }

  public getErrorMessage(): string {
    return this.ctrl.control && this.ctrl.control.errors ?
      this.messageService.getControlErrorMessage(this.ctrl.control.errors) : '';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.control && this.input) {
      if (this.ctrl.control && this.ctrl.control.value) {
        this.input.instance.set(this.ctrl.control.value);
      } else {
        this.input.instance.clear();
      }
    }
  }

  writeValue(value: any): void {}

  registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
